import { Injectable } from '@angular/core';
import { PAX_TYPE_INFANT_CODE, PAX_TYPE_ADULT_CODE, PAX_TYPE_YOUNG_ADULT_CODE, PAX_TYPE_CHILD_CODE } from '@ibe.config';
import { INDRAPassengerTypeService } from './passenger-type.indra.service';
import { INDRALanguageMarketService } from './language-market-indra.service';
import { SelectInputOption } from '@ibe.components/common/inputs/select-input-indra/models/select-input-option';
import { INDRADateService } from './date.indra.service';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

@Injectable({
	providedIn: 'root'
})
export class INDRADateValidtyService {

	maxDate;
	minDate;
	public years: SelectInputOption[];

	constructor(private passengerTypeService: INDRAPassengerTypeService,
		private languageMarketService: INDRALanguageMarketService,
		private dateService: INDRADateService) {
	}

	INDRA_checkValidBirthDate(paxType, lastDepartureDate, birthDate) {

		const mapFn = (year: number) => ({
			text: '' + year,
			value: year
		} as SelectInputOption);

		if (paxType) {
			const isUKMarket = this.languageMarketService.isUnitedKingdomMarket;
			const passengerTypeRules = this.passengerTypeService.passengerTypeRules;
			if (passengerTypeRules) {
				const currentYear = lastDepartureDate ? parseInt(moment(lastDepartureDate).format('YYYY'), 10) : new Date().getFullYear();
				let maxYear;
				let minYear;
				let maxAge;
				let minAge;

				switch (paxType) {
					case PAX_TYPE_ADULT_CODE:
						if (isUKMarket) {
							maxYear = currentYear - +passengerTypeRules.MAX_YTH_AGE;
						} else {
							maxYear = currentYear - +passengerTypeRules.MIN_ADT_AGE;
						}

						minYear = maxYear - 100;
						maxAge = currentYear - minYear;
						minAge = currentYear - maxYear;

						break;
					case PAX_TYPE_YOUNG_ADULT_CODE:
						minYear = currentYear - +passengerTypeRules.MAX_YTH_AGE;
						maxYear = currentYear - +passengerTypeRules.MIN_YTH_AGE;
						minAge = passengerTypeRules.MIN_YTH_AGE;
						maxAge = passengerTypeRules.MAX_YTH_AGE;
						break;
					case PAX_TYPE_CHILD_CODE:
						minYear = currentYear - +passengerTypeRules.MAX_CHD_AGE;
						maxYear = currentYear - +passengerTypeRules.MIN_CHD_AGE;
						minAge = passengerTypeRules.MIN_CHD_AGE;
						maxAge = passengerTypeRules.MAX_CHD_AGE;
						break;
					case PAX_TYPE_INFANT_CODE:
						minYear = currentYear - +passengerTypeRules.MAX_INF_AGE;
						maxYear = currentYear - +passengerTypeRules.MIN_INF_AGE;
						minAge = passengerTypeRules.MIN_INF_AGE;
						maxAge = passengerTypeRules.MAX_INF_AGE;
						break;
				}

				if (maxYear && minYear) {
					this.minDate = this.dateService.INDRA_subtract(lastDepartureDate, maxAge, 'years').format('YYYY-MM-DD');
					this.maxDate = this.dateService.INDRA_subtract(lastDepartureDate, minAge, 'years').format('YYYY-MM-DD');
					this.years = this.dateService.getArrayOfYears(minYear, maxYear + 1).map(mapFn);
				}
			}

		} else {
			this.years = this.dateService.getArrayOfYearsFromNowMinus100Years().map(mapFn);
			
		}
		const isValidDate = this.years.some(year => year.value == this.dateService.getYear(birthDate)) && birthDate <= this.maxDate && birthDate >= this.minDate;
		return isValidDate;
	}

}
